export type PlainMessageId = string;

export const Messages = {
    ADDRESS_CREATION_FAILED: { id: 'form.addAddress.api.error' },

    SALUTATION_MR: { id: 'salutation.mr' },
    SALUTATION_MRS: { id: 'salutation.mrs' },
    SALUTATION_NONBINARY: { id: 'salutation.nonBinary' },
    SALUTATION_UNDEFINED: { id: 'salutation.undefined' },
    SALUTATION_EMPTY: { id: 'salutation.empty' },

    VALIDATOR_VALUE_REQUIRED: { id: 'form.validator.value.required' },
    VALIDATOR_VALUE_INVALID: { id: 'form.validator.value.invalid' },
    VALIDATOR_VALUE_INVALID_ONLY_NUMBERS: { id: 'form.validator.value.invalid.only.numbers' },
    dynamic: {
        VALIDATOR_AT_LEAST: (num: number) => ({ id: 'form.validator.atLeast', values: { num } }),
        VALIDATOR_AT_MOST: (num: number) => ({ id: 'form.validator.atMost', values: { num } }),
        VALIDATOR_EXACTLY: (num: number) => ({ id: 'form.validator.exactly', values: { num } }),
        STOCK_COUNT: (stock: string) => ({ id: 'article.box.stockInfo', values: { stock } }),
    },
};
